export const OccasionI18nKeys = {
  None: _TL_('None'),
  BackToSchool: _TL_('Back to School'),
  BlackFriday: _TL_('Black Friday'),
  BoxingDay: _TL_('Boxing Day'),
  Carnival: _TL_('Carnival'),
  ChineseNewYear: _TL_('Chinese New Year'),
  Christmas: _TL_('Christmas'),
  CyberMonday: _TL_('Cyber Monday'),
  Diwali: _TL_('Diwali'),
  Easter: _TL_('Easter'),
  EidAlAdha: _TL_('Eid al-Adha'),
  EidAlFitr: _TL_('Eid al-Fitr'),
  EndOfSeason: _TL_('End of Season'),
  Epiphany: _TL_('Epiphany'),
  FallSale: _TL_('Fall Sale'),
  FathersDay: _TL_("Father's Day"),
  Halloween: _TL_('Halloween'),
  Hanukkah: _TL_('Hanukkah'),
  Holi: _TL_('Holi'),
  IndependenceDay: _TL_('Independence Day'),
  LaborDay: _TL_('Labor Day'),
  MothersDay: _TL_("Mother's Day"),
  NationalDay: _TL_('National Day'),
  Navratri: _TL_('Navratri'),
  NewYears: _TL_("New Year's"),
  ParentsDay: _TL_("Parent's Day"),
  Passover: _TL_('Passover'),
  Ramadan: _TL_('Ramadan'),
  RoshHashanah: _TL_('Rosh Hashanah'),
  SinglesDay: _TL_("Single's Day"),
  Songkran: _TL_('Songkran'),
  SpringSale: _TL_('Spring Sale'),
  StNicholasDay: _TL_('St. Nicholas Day'),
  SummerSale: _TL_('Summer Sale'),
  ValentinesDay: _TL_("Valentine's Day"),
  WinterSale: _TL_('Winter Sale'),
  WomensDay: _TL_("Women's Day"),
  YearEndGift: _TL_('Year-End Gift'),
};
